import React, { PropsWithChildren } from 'react'

interface ProvidersProps extends PropsWithChildren {}

export const Providers = ({ children }: ProvidersProps) => {
	return <>{children}</>
}
